export default __webpack_public_path__ + "static/media/seller4.6c17dab7.jpg";